import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg } from 'utils';

export const CATEGORIES_FETCH_DATA_INIT = createAction(
  'CATEGORIES_FETCH_DATA_INIT'
);
export const CATEGORIES_FETCH_DATA_SUCCESS = createAction(
  'CATEGORIES_FETCH_DATA_SUCCESS'
);
export const CATEGORIES_FETCH_DATA_FAIL = createAction(
  'CATEGORIES_FETCH_DATA_FAIL'
);

export const CATEGORIES_DELETE_CATEGORY_INIT = createAction(
  'CATEGORIES_DELETE_CATEGORY_INIT'
);
export const CATEGORIES_DELETE_CATEGORY_SUCCESS = createAction(
  'CATEGORIES_DELETE_CATEGORY_SUCCESS'
);
export const CATEGORIES_DELETE_CATEGORY_FAIL = createAction(
  'CATEGORIES_DELETE_CATEGORY_FAIL'
);

export const CATEGORIES_CLEAR_DATA = createAction('CATEGORIES_CLEAR_DATA');

export const CATEGORIES_CREATE_CATEGORY_INIT = createAction(
  'CATEGORIES_CREATE_CATEGORY_INIT'
);
export const CATEGORIES_CREATE_CATEGORY_SUCCESS = createAction(
  'CATEGORIES_CREATE_CATEGORY_SUCCESS'
);
export const CATEGORIES_CREATE_CATEGORY_FAIL = createAction(
  'CATEGORIES_CREATE_CATEGORY_FAIL'
);

export const CATEGORIES_MODIFY_CATEGORY_INIT = createAction(
  'CATEGORIES_MODIFY_CATEGORY_INIT'
);
export const CATEGORIES_MODIFY_CATEGORY_SUCCESS = createAction(
  'CATEGORIES_MODIFY_CATEGORY_SUCCESS'
);
export const CATEGORIES_MODIFY_CATEGORY_FAIL = createAction(
  'CATEGORIES_MODIFY_CATEGORY_FAIL'
);

export const CATEGORIES_CLEAN_UP = createAction('CATEGORIES_CLEAN_UP');

export const CATEGORIES_CLEAR_DATA_LOGOUT = createAction(
  'CATEGORIES_CLEAR_DATA_LOGOUT'
);

export const SET_CATEGORY = createAction('SET_CATEGORY');

export const fetchCategories = ({ categoryId, siteId }) => {
  return async (dispatch, getState) => {
    dispatch(CATEGORIES_FETCH_DATA_INIT());
    if (categoryId) {
      let categoryData;
      try {
        categoryData = await Axios.get(`${url}/poiCategory/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(CATEGORIES_FETCH_DATA_FAIL({ error }));
      }
      const category = { ...categoryData, id: categoryId };
      return dispatch(
        CATEGORIES_FETCH_DATA_SUCCESS({
          list: getState().categories.list,
          category,
        })
      );
    }

    if (siteId) {
      let categories;
      try {
        categories = await Axios.get(`${url}/poiCategory/list`, {
          params: {
            siteId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(CATEGORIES_FETCH_DATA_FAIL({ error }));
      }
      categories = categories.data.data.filter(
        (category) => category.siteId === siteId
      );

      return dispatch(
        CATEGORIES_FETCH_DATA_SUCCESS({
          list: categories,
          category: getState().categories.category,
        })
      );
    }
  };
};

export const deleteCategory = (id, siteId, cb) => {
  return async (dispatch) => {
    dispatch(CATEGORIES_DELETE_CATEGORY_INIT());

    try {
      await Axios.delete(`${url}/poiCategory/delete`, {
        params: {
          id,
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage, { icon: 'error' });
      return dispatch(
        CATEGORIES_DELETE_CATEGORY_FAIL({
          error: errorMessage,
        })
      );
    }

    toastr.success('', 'The category was deleted.');
    cb();
    return dispatch(CATEGORIES_DELETE_CATEGORY_SUCCESS({ id }));
  };
};

export const clearCategoriesData = () => {
  return (dispatch) => {
    dispatch(CATEGORIES_CLEAR_DATA());
  };
};

export const clearCategoriesDataLogout = () => {
  return (dispatch) => {
    dispatch(CATEGORIES_CLEAR_DATA_LOGOUT());
  };
};

export const createCategory = ({ name, description, siteId, file }, cb) => {
  return async (dispatch) => {
    dispatch(CATEGORIES_CREATE_CATEGORY_INIT());
    let category;
    try {
      const categoryData = new FormData();
      categoryData.set('name', name);
      categoryData.set('description', description);
      categoryData.set('siteId', siteId);
      if (file) categoryData.append('file', file);

      category = await Axios.post(`${url}/poiCategory/create`, categoryData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      log(error.response, '<<< error response');
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        CATEGORIES_CREATE_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    toastr.success('', 'Category created successfully');
    cb();
    dispatch(
      SET_CATEGORY({
        data: {
          name: '',
          description: '',
        },
      })
    );

    return dispatch(
      CATEGORIES_CREATE_CATEGORY_SUCCESS({ category: category.data.data })
    );
  };
};

export const modifyCategory = (
  { id, name, description, logo, file, siteId, modifiedAt, modifiedBy },
  cb
) => {
  return async (dispatch) => {
    dispatch(CATEGORIES_MODIFY_CATEGORY_INIT());

    const categoryData = new FormData();
    categoryData.set('id', id);
    categoryData.set('name', name);
    categoryData.set('description', description);
    categoryData.set('siteId', siteId);
    categoryData.set('modifiedAt', modifiedAt);
    categoryData.set('modifiedBy', modifiedBy);
    if (logo) categoryData.set('logo', logo);
    if (file) categoryData.append('file', file);

    let updateCategoryDbTask;
    try {
      updateCategoryDbTask = await Axios.post(
        `${url}/poiCategory/edit`,
        categoryData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      // await Promise.all([updateCategoryDbTask]);
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);

      return dispatch(
        CATEGORIES_MODIFY_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Category updated successfully');
    cb();
    dispatch(
      SET_CATEGORY({
        data: {
          name: '',
          description: '',
        },
      })
    );
    return dispatch(
      CATEGORIES_MODIFY_CATEGORY_SUCCESS({
        category: updateCategoryDbTask.data.data,
        id,
      })
    );
  };
};

export const categoriesCleanUp = () => (dispatch) =>
  dispatch(CATEGORIES_CLEAN_UP());

export const setCategory = (data, cb) => {
  return (dispatch) => {
    dispatch(SET_CATEGORY({ data }));
    if (cb) {
      cb();
    }
  };
};
